// L'univers de soins ouvert par la page des prestations voyage dans l'adresse :
// la page introuvable renvoie sur une famille précise, et un lien se partage.
// Le nom du paramètre est un contrat entre deux écrans — écrit une fois de
// chaque côté, il se serait désaccordé au premier renommage.
export const PARAM_UNIVERS = 'univers'

export function lienVersUnivers(familyId) {
  return `/services?${PARAM_UNIVERS}=${encodeURIComponent(familyId)}`
}
